import chartColors from '../../constants/chartColors';
import {ThemeColors} from '../../helpers/ThemeColors';
import {numberWithCommas} from '../../helpers/Utils';

export const areaChart = index => ({
  backgroundColor: chartColors[`color_${index}${index}`],
  borderColor: chartColors[`color_${index}`],
  pointBackgroundColor: ThemeColors().foregroundColor,
  pointHoverBackgroundColor: chartColors[`color_${index}`],
  borderWidth: 2,
  pointBorderWidth: 2,
  pointRadius: 5,
  pointHoverRadius: 5,
});

export const chartTooltip = {
  backgroundColor: ThemeColors().foregroundColor,
  titleFontColor: ThemeColors().primaryColor,
  borderColor: ThemeColors().separatorColor,
  borderWidth: 0.5,
  bodyFontColor: ThemeColors().primaryColor,
  bodySpacing: 10,
  xPadding: 15,
  yPadding: 15,
  cornerRadius: 0.15,
  callbacks: {
    label: function(tooltipItem, data) {
      let value = data.datasets[0].data[tooltipItem.index];
      return numberWithCommas(value);
    }
  }
};

export const barValueOnTop = {
  beforeDraw: function (chart) {
    var ctx = chart.chart.ctx;
    ctx.font = '14px IRANSans';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    var values = [];
    chart.data.datasets.forEach(function (dataset, i) {
      var meta = chart.controller.getDatasetMeta(i);
      meta.data.forEach(function (bar, index) {
        var data = !meta.hidden ? dataset.data[index] : 0;
        values[index] = values[index] ? values[index] + data : data;
      });
    });
    chart.controller.getDatasetMeta(chart.data.datasets.length - 1).data.forEach(function (bar, index) {
      var dataset = chart.data.datasets[chart.data.datasets.length - 1];
      var model = dataset._meta[Object.keys(dataset._meta)[0]].data[index]._model;
      var scaleMax = dataset._meta[Object.keys(dataset._meta)[0]].data[index]._yScale.maxHeight;
      var yPos = (scaleMax - model.y) / scaleMax >= 0.93 ? model.y + 20 : model.y - 5;
      ctx.fillText(values[index], model.x, yPos);
      // ctx.fillText(values[index], bar._model.x, bar._model.y - 5 < 23 ? 23 : bar._model.y - 5);
    });
  },
};

export const centerTextPlugin = {
  afterDatasetsUpdate: function (chart) {
  },
  beforeDraw: function (chart) {
    var width = chart.chartArea.right;
    var height = chart.chartArea.bottom;
    var ctx = chart.chart.ctx;
    ctx.restore();

    var activeLabel = chart.data.labels[0];
    var activeValue = chart.data.datasets[0].data[0];
    var dataset = chart.data.datasets[0];
    var meta = dataset._meta[Object.keys(dataset._meta)[0]];
    var total = meta.total;

    var activePercentage = parseFloat(((activeValue / total) * 100).toFixed(1));
    activePercentage = chart.legend.legendItems[0] ? chart.legend.legendItems[0].hidden
      ? 0
      : activePercentage
      : null;

    if (chart.pointAvailable) {
      activeLabel = chart.data.labels[chart.pointIndex];
      activeValue =
        chart.data.datasets[chart.pointDataIndex].data[chart.pointIndex];

      dataset = chart.data.datasets[chart.pointDataIndex];
      meta = dataset._meta[Object.keys(dataset._meta)[0]];
      total = meta.total;
      activePercentage = parseFloat(((activeValue / total) * 100).toFixed(1));
      activePercentage = chart.legend.legendItems[chart.pointIndex].hidden ? 0 : activePercentage;
    }

    ctx.font = '36px IRANSans';
    ctx.fillStyle = ThemeColors().primaryColor;
    ctx.textBaseline = 'middle';

    var text = activePercentage + '%';
    var textX = Math.round((width - ctx.measureText(text).width) / 2);
    var textY = (1.15 * height) / 2;
    ctx.fillText(text, textX, textY);

    ctx.font = '14px IRANSans';
    ctx.textBaseline = 'middle';

    var text2 = activeLabel;
    var textX2 = Math.round((width - ctx.measureText(text2).width) / 2);
    var textY2 = height / 2 - 30;
    ctx.fillText(text2, textX2, textY2);

    ctx.save();
  },
  beforeEvent: function (chart, event, options) {
    var firstPoint = chart.getElementAtEvent(event)[0];

    if (firstPoint) {
      chart.pointIndex = firstPoint._index;
      chart.pointDataIndex = firstPoint._datasetIndex;
      chart.pointAvailable = true;
    }
  }
};
